// noinspection ES6UnusedImports
import React, {useEffect, useState} from 'react';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import {Link, Price as DesyPrice, Tooltip, Typography} from '@bonprix/design-system';
import ProductMessages from './message-list';
import Icon from '@bonprix/pattern-library/templates/icon';
import Landmark from '@core/scripts/components/landmark-adapter';

let tooltipOpenLandmarkSent;

export default function Price({product, texts, staticLinks}) {
    const [currentItem, setCurrentItem] = useState(product.currentItem);
    const [currentItemOption, setCurrentItemOption] = useState(product.currentItemOption);

    useEffect(() => {
        const subscription = MessageBroker.subscribe(ProductMessages.CHANGED, ({item, itemOption}) => {
            if (item !== undefined) {
                setCurrentItem(item);
            }
            if (itemOption !== undefined) {
                setCurrentItemOption(itemOption);
            }
        });

        return () => MessageBroker.unsubscribe(subscription);
    }, []);

    const sendTooltipOpenLandmark = () => {
        if (!tooltipOpenLandmarkSent) {
            Landmark.sendClickLandmark('adp_shippingcost');
            tooltipOpenLandmarkSent = true;
        }
    };

    const sendMoreInfoLandmark = () => {
        Landmark.sendClickLandmark('adp_shippingcost_info');
    };

    const getMoreInfoLink = (staticLinks, texts) => {
        return (
            <div key={3} className="product__delivery-more-info">
                <Link
                    arrowPosition={'right'}
                    showArrow
                    href={staticLinks.deliveryCostsMoreInfoUrl}
                    target="_blank"
                    onClick={sendMoreInfoLandmark}
                >
                    {texts.bbff_ada_info_shipping_information_more_info}
                </Link>
            </div>
        );
    };

    const price = product.coliCount > 0 ? currentItem.price : (currentItemOption || currentItem).price;

    const priceVariant = () => {
        if (price?.current.unknownPrice) return 'no-price';
        if (price?.current.bestPrice) return 'best-price';
        if (price?.former) return 'sale';
        return 'regular';
    };

    const renderDeliveryInformation = (price) => {
        if (!price?.current.unknownPrice) {
            const tooltipContent = (
                <Typography variant="body1" component="span">
                    {texts.bff_ada_info_shipping_information_charges}
                    {product.additionalDeliveryInfo && <div key={1}>{product.additionalDeliveryInfo}</div>}
                    {getMoreInfoLink(staticLinks, texts)}
                </Typography>
            );

            return (
                <div className={'product__delivery-info-container'}>
                    <Typography variant="body1" component="div">
                        <div className="product__delivery-text">
                            {texts.bff_ada_tax_included}&nbsp;
                            <span className="product__delivery-tooltip-wrapper" onMouseEnter={sendTooltipOpenLandmark}>
                                <Tooltip content={tooltipContent}>
                                    <span className="product__delivery-tooltip-label">
                                        <span className="product__delivery-costs">
                                            {currentItem?.carrierExtraCharge
                                                ? texts.bff_ada_info_icon_shipping_bigsize_headline
                                                : texts.bff_ada_info_icon_shipping_headline}
                                        </span>
                                        <Icon name="hint" className="product__delivery-tooltip-icon" />
                                    </span>
                                </Tooltip>
                            </span>
                        </div>
                    </Typography>
                </div>
            );
        }
    };

    return (
        <>
            <DesyPrice
                variant={priceVariant()}
                currentPrice={price.current ? Number(price.current.rawValue) : undefined}
                size={'large'}
                amount={price.current?.packItemsCount}
                showUnits={price.current?.packItemsCount > 1}
                isFromPrice={!price.current.uniquePrice}
                oldPrice={price.former ? Number(price.former.rawValue) : undefined}
            />
            {renderDeliveryInformation(price)}
        </>
    );
}
